import react, { Component, createRef } from "react";
import Footer from "./footer";
import Header from "./Header";
import ContentLoader from "react-content-loader";
import CryptoJS from "crypto-js";
import Cookies from "js-cookie";
import { connect } from "react-redux";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { PhoneInput } from "react-international-phone";
import { PhoneNumberUtil } from "google-libphonenumber";
import Select from "react-select";
import countryList from "react-select-country-list";
import {
  addSettings,
  addMsaInfo,
  setClientLeftMenu,
  setQuotationSettings,
} from "../../actions";

import LefeSideBar from "./leftSideBar";
import Dashboard from "../../Pages/Client/Dashboard";
import Services from "../../Pages/Client/Services";
import Agreements from "../../Pages/Client/Agreements";
import UnsignedAgreements from "../../Pages/Client/Agreements/unsignedagreements";
import UnsignedAgreement from "../../Pages/Client/Agreements/unsigned_single";
import Pdfdownload from "../../Pages/Client/Agreements/pdfdownload";

import Help from "../../Pages/Client/Help";
import CreditApp from "../../Pages/Client/CreditApp";
import AddCreditApp from "../../Pages/Client/CreditApp/addCreditApp";

import MetabaseReports from "../../Pages/Client/MetabaseReports";
import RequestReports from "../../Pages/Client/MetabaseReports/requestReport";
import EditRequest from "../../Pages/Client/MetabaseReports/editRequest";
import ViewRequest from "../../Pages/Client/MetabaseReports/viewRequest";

import SubClients from "../../Pages/Client/SubClients";
import AddSubClient from "../../Pages/Client/SubClients/addsubclient";

import AccountActivity from "../../Pages/Client/AccountActivity";
import KycForm from "../../Pages/Client/KycForm";
import Rfqs from "../../Pages/Client/Rfqs";
import AddRfq from "../../Pages/Client/Rfqs/addRfq";
import EditRfq from "../../Pages/Client/Rfqs/editRfq";

import Quotations from "../../Pages/Client/Quotations";
import ViewQuotation from "../../Pages/Client/Quotations/viewQuotation";

import SalesOrders from "../../Pages/Client/SalesOrders";
import ViewSalesOrder from "../../Pages/Client/SalesOrders/viewOrder";
import EditSalesOrder from "../../Pages/Client/SalesOrders/addOrder";

import ClientDocuments from "../../Pages/Client/Documents";

import Forms from "../../Pages/Client/Forms";
import FormSubmit from "../../Pages/Client/Forms/form_submit";
import FormSubmissions from "../../Pages/Client/Forms/form_submissions";
import FormSubmissionSingle from "../../Pages/Client/Forms/form_single_submission";

import BillingInformation from "../../Pages/Client/Billing";
import Invoices from "../../Pages/Client/Billing/Invoices";
import PaymentHistory from "../../Pages/Client/Billing/PaymentHistory";
import Pricing from "../../Pages/Client/Billing/Pricing";

import Loaders from "../../Pages/Client/Loaders";

import Cdr from "../../Pages/Client/Reporting";
import SmsRecords from "../../Pages/Client/Reporting/SmsRecords";
import MouStats from "../../Pages/Client/Reporting/MouStats";
import BalanceUsage from "../../Pages/Client/Reporting/BalanceUsage";

import ApiKey from "../../Pages/Client/ApiKey";

import MSA from "../../Pages/Reseller/MSA";
import DashboardLoader from "../ContentLoaders/dashboard_loader";
import ErrorPage from "../Errors/404";
import AccessDenied from "../Errors/ClientAccessDenied";

import MutextField from "@material-ui/core/TextField";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";

import {
  getAccountData,
  profileUpdate,
  clientLeftMenu,
  getQuotationSettings,
  getClientPermissionData,
  getContactAgentDetails
} from "../../config/client_api_calls";
import {
  LOGO,
  THEME_COLOR,
  THEME_TEXT_COLOR,
  VENDOR_SIGNATURE,
  APP_LIVE_URL,
  API_URL,
} from "../../config/config";
import { REPLACECONTENT, ValidateEmail, normalize } from "../../config/utility";
import HelperClass from "./../../config/helperClass";
import Agreement from "./agreement_new";

import TextField from "../InputFields/TextField";

import PasswordStrengthBar from "react-password-strength-bar";
import Tooltip from "@material-ui/core/Tooltip";

const auth = new HelperClass();

const pageAssociations = {
  CreditApp: ["AddCreditApp"],
  SalesOrders: ["ViewSalesOrder", "EditSalesOrder"],
  Rfqs: ["AddRfq", "EditRfq"],
  Quotations: ["ViewQuotation"],
  SubClients: ["AddSubClient"],
  forms: [
    "client_form_submit",
    "client_form_submissions",
    "client_form_submission_single",
  ],
  MetabaseReports: ["requestReports", "editRequest", "viewRequest"],
  //Forms: ["forms"]
};

class Main extends Component {
  constructor(props) {
    super(props);

    if (auth.isClientLogin() === false) {
      auth.clientLogout();
    }

    this.state = {
      view: this.props.view,
      activePage: "",
      is_msa_signed: false,
      Agreement_Content: "",
      title_agreement: "",
      bgColor: "#ffffff",
      vendor_signor_signature_file: "",
      published_date: "",
      defaultLoader: true,
      errorCompName: "",
      comp_name: "",
      errorName: "",
      name: "",
      errorTitle: "",
      title: "",
      errorEmail: "",
      email: "",
      errorPhone: "",
      phone: "",
      errorPass: "",
      password: "",
      confirm_password: "",
      errorAddress: "",
      address: "",
      errorCity: "",
      city: "",
      errorState: "",
      states: "",
      errorZip: "",
      zip: "",
      errorMessage: "",
      disabled: "",
      successMessage: "",
      routingUrl: "",
      filer_id: "",
      passwordShown: false,
      confirmPasswordShown: false,
      errorAddress2: "",
      address2: "",
      country: "",
      errorCountry: "",
      isLoading: true,
      useGooglePlaces: true,
      toggleButtonText: "Allow PO Box Address",

      clientData: [],
      integrationInfo: [],
      parentIntegration: [],
      voicePermissionAdmin: "",

      loginDetails: [],
      errorMessageContactAgent: "",
      successMessageContactAgent: "",
      contact_loader: false,
      contact_subject: "",
      contact_comment: ""
    };
    this.phoneInputRef = createRef();
    this.countryOptions = countryList()
      .getData()
      .filter(
        (country) => country.label !== "United States Minor Outlying Islands"
      );
  }

  async componentDidMount() {
    this.setState({ isLoading: true });

    const phoneNumber = await auth.getPhoneClient();
    this.setState({
      comp_name: auth.getCompNameClient(),
      name: auth.getNameClient(),
      email: auth.getEmailClient(),
      phone: auth.getPhoneClient(),
      filer_id: auth.getFilerID(),
      phone: phoneNumber,
      title: auth.getTitleClient() === false ? "" : auth.getTitleClient(),
    });
    this.defaultChecks();
    await this.getLeftMenu();
    await this.getClientPermissionData();
    await this.getQuotationSetting();
    this.setState({ isLoading: false });
    const urlParams = new URLSearchParams(window.location.search);
    const redirect = urlParams.get("redirect");

    if (redirect === "profile") {
      window.$("#modalFormProfile").modal("show");
    }
  }

  getClientPermissionData = async () => {
    let acctno = auth.getClientAccount();

    let res = await getClientPermissionData(
      acctno,
      auth.getClientToken(),
      auth.getEmailClient()
    );
    //console.log("getClientPermissionData: ", res.data);
    if (res.data.status === 200 && res.data.message === "success") {
      this.setState({
        clientData: res.data.clientData,
        integrationInfo: res.data.integrationInfo,
        parentIntegration: res.data.parentIntegration,
        voicePermissionAdmin: res.data.voicePermissionAdmin,
      });
    }
  };

  loginDetailView = () => {
    this.setState({ successMessage: "", errorMessage: "" });
    window.$("#modalLoginDetail").modal("show");
  };

  getLeftMenu = async () => {
    let acctno = auth.getClientAccount();

    let res = await clientLeftMenu(
      acctno,
      auth.getClientToken(),
      auth.getEmailClient()
    );
    //console.log("getClientLeftMenu: ", res.data);
    if (
      res.data.status === 200 &&
      res.data.message === "success" &&
      res.data.data.length > 0
    ) {
      // Dispatch action to update left menu in Redux
      this.props.setClientLeftMenu(res.data.data);
      this.setState({ loginDetails: res.data.loginDetails });
    }
  };

  getQuotationSetting = async () => {
    let acctno = auth.getClientAccount();

    let res = await getQuotationSettings(
      acctno,
      auth.getClientToken(),
      auth.getEmailClient()
    );
    //console.log("getQuotationSettings: ", res.data);
    if (
      res.data.status === 200 &&
      res.data.message === "success" &&
      res.data.data.length > 0
    ) {
      // Dispatch action to update left menu in Redux
      this.props.setQuotationSettings(res.data.data);
    }
  };

  phoneUtil = PhoneNumberUtil.getInstance();

  isPhoneValid = (phone) => {
    try {
      return this.phoneUtil.isValidNumber(
        this.phoneUtil.parseAndKeepRawInput(phone)
      );
    } catch (error) {
      return false;
    }
  };

  handleFocus = () => {
    // Move cursor to the end of the input value
    const input = this.phoneInputRef.current;
    if (input) {
      const value = input.value;
      input.setSelectionRange(value.length, value.length);
    }
  };

  handleToggle = () => {
    this.setState((prevState) => ({
      useGooglePlaces: !prevState.useGooglePlaces,
      toggleButtonText:
        prevState.toggleButtonText === "Allow PO Box Address"
          ? "Allow Simple Address"
          : "Allow PO Box Address",
    }));
  };

  handleAddressSelect = async (place) => {
    const { description } = place.value;
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
          description
        )}&key=${process.env.REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY}`
      );
      const data = await response.json();

      if (data.status === "OK") {
        const addressComponents = data.results[0].address_components;
        const formattedAddress = data.results[0].formatted_address;
        console.log("addressComponents", addressComponents);
        let city = null;
        let state = null;
        let country = null;
        let zipCode = null;
        let streetAddress = "";
        let neighborhood = null;
        let locality = null;
        let address2 = "";

        addressComponents.forEach((component) => {
          if (component.types.includes("neighborhood")) {
            neighborhood = component.long_name;
          } else if (component.types.includes("locality")) {
            locality = component.long_name;
          } else if (component.types.includes("administrative_area_level_1")) {
            state = component.short_name;
          } else if (component.types.includes("country")) {
            country = component.long_name;
          } else if (component.types.includes("postal_code")) {
            zipCode = component.long_name;
          } else if (component.types.includes("subpremise")) {
            address2 = component.long_name;
          } else if (
            ![
              "sublocality",
              "sublocality_level_1",
              "sublocality_level_2",
              "administrative_area_level_2",
              "administrative_area_level_3",
              "postal_code_suffix",
            ].includes(component.types[0])
          ) {
            if (streetAddress !== "") {
              streetAddress += " ";
            }
            streetAddress += component.long_name;
          }
        });

        // Check if neighborhood is part of the formatted address
        if (neighborhood && formattedAddress.includes(neighborhood)) {
          city = neighborhood;
        } else {
          city = locality;
        }

        this.setState({
          city: city && city !== "" ? city : "",
          states: state && state !== "" ? state : "",
          zip: zipCode && zipCode !== "" ? zipCode : "",
          country: country && country !== "" ? country : "",
          address: streetAddress && streetAddress !== "" ? streetAddress : "",
          address2: address2 && address2 !== "" ? address2 : "",
        });
      } else {
        console.error("Reverse geocoding request failed:", data.status);
      }
    } catch (error) {
      console.error("Error fetching reverse geocoding data:", error);
    }
  };

  handleChangeCountry = (event) => {
    console.log("event.label: ", event.label);
    const country = event.label;
    this.setState({
      country: country,
    });
  };

  formUpdate = async () => {
    let {
      name,
      email,
      comp_name,
      title,
      phone,
      address,
      city,
      states,
      zip,
      password,
      confirm_password,
      is_msa_signed,
      address2,
      country,
    } = this.state;
    const modalBody = document.getElementById("modalFormProfile");
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
    if (modalBody) {
      setTimeout(() => {
        modalBody.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }, 0);
    }

    let is_validated = true;
    if (comp_name === "") {
      this.setState({
        errorCompName: "error",
        errorMessage: "Company Name is required.",
      });
      is_validated = false;
    } else if (name === "") {
      this.setState({
        errorCompName: "",
        errorName: "error",
        errorMessage: "Full Name is required.",
      });
      is_validated = false;
    } else if (phone === "") {
      this.setState({
        errorCompName: "",
        errorName: "",
        errorPhone: "error",
        errorMessage: "Phone is required.",
      });
      is_validated = false;
    } else if (!this.isPhoneValid(phone)) {
      this.setState({
        errorCompName: "",
        errorName: "",
        errorPhone: "error",
        errorMessage: "Invalid phone format.",
      });
      is_validated = false;
    } else if (address === "") {
      this.setState({
        errorCompName: "",
        errorName: "",
        errorPhone: "",
        errorAddress: "error",
        errorMessage: "Address is required.",
      });
      is_validated = false;
    } else if (city === "") {
      this.setState({
        errorCompName: "",
        errorName: "",
        errorPhone: "",
        errorAddress: "",
        errorCity: "error",
        errorMessage: "City is required.",
      });
      is_validated = false;
    } else if (states === "") {
      this.setState({
        errorCompName: "",
        errorName: "",
        errorPhone: "",
        errorAddress: "",
        errorCity: "",
        errorState: "error",
        errorMessage: "State is required.",
      });
      is_validated = false;
    } else if (zip === "") {
      this.setState({
        errorCompName: "",
        errorName: "",
        errorPhone: "",
        errorAddress: "",
        errorCity: "",
        errorState: "",
        errorZip: "error",
        errorMessage: "Zip is required.",
      });
      is_validated = false;
    } else if (country === "") {
      this.setState({
        errorCompName: "",
        errorName: "",
        errorPhone: "",
        errorAddress: "",
        errorCity: "",
        errorState: "",
        errorZip: "",
        errorCountry: "error",
        errorMessage: "Country is required.",
      });
      is_validated = false;
    } else if (ValidateEmail(email) === false) {
      this.setState({
        errorEmail: "error",
        errorName: "",
        errorMessage: "Invalid email format.",
      });
      is_validated = false;
    } else if (password !== "") {
      if (password.length < 8) {
        this.setState({
          errorCompName: "",
          errorName: "",
          errorPhone: "",
          errorAddress: "",
          errorCity: "",
          errorState: "",
          errorZip: "",
          errorCountry: "",
          errorPass: "error",
          errorMessage: "Use 8 characters or more for your password",
        });
        is_validated = false;
      } else if (!passwordRegex.test(password)) {
        this.setState({
          errorCompName: "",
          errorName: "",
          errorPhone: "",
          errorAddress: "",
          errorCity: "",
          errorState: "",
          errorZip: "",
          errorCountry: "",
          errorPass: "error",
          errorMessage:
            "Password must be at least 8 characters, with uppercase, lowercase, number & special character.",
        });
        is_validated = false;
      } else if (confirm_password === "") {
        this.setState({
          errorCompName: "",
          errorName: "",
          errorPhone: "",
          errorAddress: "",
          errorCity: "",
          errorState: "",
          errorZip: "",
          errorCountry: "",
          errorPass: "error",
          errorMessage: "Confirm password is required.",
        });
        is_validated = false;
      } else if (confirm_password.length < 8) {
        this.setState({
          errorCompName: "",
          errorName: "",
          errorPhone: "",
          errorAddress: "",
          errorCity: "",
          errorState: "",
          errorZip: "",
          errorCountry: "",
          errorPass: "error",
          errorMessage: "Use 8 characters or more for your confirm password",
        });
        is_validated = false;
      } else if (password.trim() != confirm_password.trim()) {
        this.setState({
          errorCompName: "",
          errorName: "",
          errorPhone: "",
          errorAddress: "",
          errorCity: "",
          errorState: "",
          errorZip: "",
          errorCountry: "",
          errorPass: "error",
          errorMessage: "Password and confirm password does not match.",
        });
        is_validated = false;
      }
    }
    if (is_validated) {
      this.setState({
        errorCompName: "",
        errorName: "",
        errorAddress: "",
        errorCity: "",
        errorState: "",
        errorZip: "",
        errorCountry: "",
        errorPass: "",
        errorEmail: "",
        errorMessage: "",
        errorConfirm: "",
        errorPhone: "",
        errorTitle: "",
        disabled: true,
      });

      let apiResponce = await profileUpdate(
        auth.getClientAccount(),
        auth.getClientToken(),
        name,
        title,
        comp_name,
        phone,
        address,
        city,
        states,
        zip,
        password,
        address2,
        country
      );
      //console.log(apiResponce);
      if (
        apiResponce.data.status === 403 ||
        apiResponce.data.errors === "authentication missing" ||
        apiResponce.data.errors === "jwt expired"
      ) {
        auth.clientLogout();
      } /*else if (
        apiResponce.data.status === 409 &&
        apiResponce.data.message === "Address validation failed"
      ) {
        this.setState({
          errorMessage:
            "Address validation failed. Check if zip, state, city, and country are correctly matched.",
          disabled: false,
        });
      }*/ else if (
        apiResponce.data.status === 409 &&
        apiResponce.data.message === "Address validation failed"
      ) {
        const formattedErrorMessage = apiResponce.data.errors
          ? String(apiResponce.data.errors).replace(/,/g, "<br />")
          : "Address validation failed";

        this.setState({
          errorMessage: formattedErrorMessage,
          disabled: false,
        });
      } else if (
        apiResponce.data.status === 200 &&
        apiResponce.data.message === "success"
      ) {
        await this.getClientPermissionData();
        Cookies.set(
          "client_comp_nme__",
          CryptoJS.AES.encrypt(
            apiResponce.data.data[0]["comp_name"],
            process.env.REACT_APP_SIGNATURE
          ).toString()
        );
        Cookies.set(
          "client_name__",
          CryptoJS.AES.encrypt(
            apiResponce.data.data[0]["name"],
            process.env.REACT_APP_SIGNATURE
          ).toString()
        );
        Cookies.set(
          "client_phone__",
          CryptoJS.AES.encrypt(
            apiResponce.data.data[0]["phone"],
            process.env.REACT_APP_SIGNATURE
          ).toString()
        );
        Cookies.set(
          "client_title__",
          CryptoJS.AES.encrypt(
            apiResponce.data.data[0]["title"],
            process.env.REACT_APP_SIGNATURE
          ).toString()
        );

        this.setState({
          successMessage: "Profile updated successfully.",
          disabled: false,
        });
        if (is_msa_signed === false) {
          window.location.reload();
        }
        /*setTimeout(async function () {
          window.$("#modalFormProfile").modal("hide");
        }, 2000);*/

        setTimeout(
          async function () {
            const { integrationInfo, voicePermissionAdmin, parentIntegration } =
              this.state;
            const userType = auth.getUserTypeClient();

            let shouldRedirect = false;

            if (userType === "Super") {
              // For Super users, check the integrationInfo as before
              if (voicePermissionAdmin === "Yes") {
                if (integrationInfo && integrationInfo.length > 0) {
                  if (integrationInfo[0]["enable"] === "Yes") {
                    shouldRedirect = true;
                  }
                }
              }
            } else if (userType === "Sub") {
              // For Sub users, check both integrationInfo and parentIntegration
              if (voicePermissionAdmin === "Yes") {
                if (
                  integrationInfo &&
                  integrationInfo.length > 0 &&
                  parentIntegration &&
                  parentIntegration.length > 0
                ) {
                  if (
                    integrationInfo[0]["enable"] === "Yes" &&
                    parentIntegration[0]["enable"] === "Yes"
                  ) {
                    shouldRedirect = true;
                  }
                }
              }
            }
            window.$("#modalFormProfile").modal("hide");
            if (shouldRedirect) {
              this.handleRedirect();
            } else {
              if (auth.getVAReturnUrl() && auth.getVAReturnUrl() !== "") {
                window.$("#modalAlertPermission").modal("show");
              }

              console.log(
                "Redirect condition not met, staying on the current page."
              );
            }
          }.bind(this),
          2000
        );
      } else if (
        apiResponce.data.status === 404 &&
        apiResponce.data.message === "fail"
      ) {
        this.setState({
          errorMessage: "Something went wrong,try later.",
          disabled: false,
        });
        return false;
      } else {
        auth.clientLogout();
      }
    }
  };

  contactAgent = async () => {
    this.setState({
      successMessageContactAgent: "",
      errorMessageContactAgent: "",
      contact_loader: true,
      contact_subject: "",
      contact_comment: ""
    });
    window.$("#modalContactAgent").modal("show");
    let apiResponce = await getContactAgentDetails(
      auth.getClientAccount(),
      auth.getClientToken(),
    );
    if (
      apiResponce.data.status === 403 ||
      apiResponce.data.errors === "authentication missing" ||
      apiResponce.data.errors === "jwt expired"
    ) {
      auth.clientLogout();
    } else if (
      apiResponce.data.status === 200 &&
      apiResponce.data.message === "success"
    ) {
      this.setState({
        successMessageContactAgent: "",
        errorMessageContactAgent: "",
        contact_loader: false,
        contact_subject: "",
        contact_comment: ""
      });
    } else {
      this.setState({
        successMessageContactAgent: "",
        errorMessageContactAgent: "",
        contact_loader: false,
        contact_subject: "",
        contact_comment: ""
      });
    }

  };

  contactAgentSubmit = async () => {
    const { contact_subject, contact_comment } = this.state;
  }

  pythonEncrypt = (data, passphrase) => {
    const secretKey = CryptoJS.enc.Hex.parse(passphrase);
    const iv = CryptoJS.lib.WordArray.random(16);

    const encrypted = CryptoJS.AES.encrypt(data, secretKey, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    // Concatenate raw IV + ciphertext (in binary form)
    const rawIv = iv;
    const rawCiphertext = CryptoJS.enc.Base64.parse(encrypted.toString());

    const combined = rawIv.concat(rawCiphertext);

    const base64Encoded = CryptoJS.enc.Base64.stringify(combined);

    return base64Encoded
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/, "");
  };


  handleRedirect = () => {
    console.log("clientData", this.state.clientData);

    let accountno = auth.getClientAccount();
    let parent_accountno = auth.getParentAcctClient();
    let email = auth.getEmailClient();
    let firstName = auth.getNameClient();
    let compName = auth.getCompNameClient();
    let userType = auth.getUserTypeClient();
    let address =
      this.state.clientData &&
      this.state.clientData.length > 0 &&
      this.state.clientData[0].address;
    let title =
      this.state.clientData &&
      this.state.clientData.length > 0 &&
      this.state.clientData[0].title;
    let phone =
      this.state.clientData &&
      this.state.clientData.length > 0 &&
      this.state.clientData[0].phone;
    let country =
      this.state.clientData &&
      this.state.clientData.length > 0 &&
      this.state.clientData[0].country;
    let city =
      this.state.clientData &&
      this.state.clientData.length > 0 &&
      this.state.clientData[0].city;
    let zip =
      this.state.clientData &&
      this.state.clientData.length > 0 &&
      this.state.clientData[0].zip;
    let state =
      this.state.clientData &&
      this.state.clientData.length > 0 &&
      this.state.clientData[0].state;
    let account_status =
      this.state.clientData &&
      this.state.clientData.length > 0 &&
      this.state.clientData[0].account_status;
    let return_url = APP_LIVE_URL + auth.getResellerRegToken() + "/client";

    let status = account_status === "active" ? 1 : 0;

    let tokenData = {
      accountno,
      email,
      firstName,
      compName,
      userType,
      status,
      title,
      phone,
      address,
      city,
      state,
      zip,
      country,
      return_url,
    };

    if (userType === "Sub") {
      tokenData.parent_accountno = parent_accountno;
    }

    const tokenDataString = JSON.stringify(tokenData);

    const secretKey = process.env.REACT_APP_CARRIER_VOICE_ALERTS_SECRET_KEY;
    const encryptedToken = this.pythonEncrypt(tokenDataString, secretKey);
    const baseUrl = process.env.REACT_APP_CARRIER_VOICE_ALERTS_URL_PROFILE;
    const url = `${encryptedToken}`;
    if (auth.getVAReturnUrl() && auth.getVAReturnUrl() !== "") {
      window.open(`${baseUrl}${url}`, "_blank");
    }
  };

  modalHideRemoveAlert = (modal_id) => {
    window.$("#" + modal_id).modal("hide");
  };

  togglePassword = () => {
    this.setState({
      passwordShown: !this.state.passwordShown,
    });
  };

  toggleConfirmPassword = () => {
    this.setState({
      confirmPasswordShown: !this.state.confirmPasswordShown,
    });
  };

  handleChange = (event) => {
    const { target } = event;
    let value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;
    if (name === "name") {
      value = value.replace(/[^a-zA-Z\s'.,-]/g, "");
    } else if (name === "title") {
      value = value.replace(/[^a-zA-Z0-9\s\-_.,&()]/g, "");
    } else if (name === "comp_name") {
      value = value.replace(/[^a-zA-Z0-9\s\-_,&().]/g, "");
    }
    this.setState({
      [name]: value,
    });
  };


  agreementSigned = () => {
    this.setState({ is_msa_signed: true });
  };

  defaultChecks = async () => {
    let apiData = await getAccountData(
      auth.getClientAccount(),
      auth.getClientToken()
    );
    console.log("Agreement DATA: ", apiData.data);
    if (
      apiData.data.status === 403 ||
      apiData.data.errors === "authentication missing" ||
      apiData.data.errors === "jwt expired"
    ) {
      auth.clientLogout();
    } else if (
      apiData.data.status === 404 ||
      (apiData.data.data && apiData.data.data.length === 0)
    ) {
      console.log("First 404 Error");
      //this.props.history.push("/error");
    } else if (apiData.data.status === 200 && apiData.data.data.length > 0) {
      this.props.addSettings(apiData.data.resellers_setting);
      this.props.addMsaInfo(apiData.data.agreement);

      this.setState({
        address: apiData.data.data[0]["address"],
        city: apiData.data.data[0]["city"],
        states: apiData.data.data[0]["state"],
        zip: apiData.data.data[0]["zip"],
        address2: apiData.data.data[0]["address2"],
        country: apiData.data.data[0]["country"],
        routingUrl: apiData.data.url,
      });
      if (apiData.data.agreement === "No") {
        this.setState({
          is_msa_signed: false,
          defaultLoader: false,
        });
      } else if (apiData.data.agreement === "Yes") {
        this.setState({
          is_msa_signed: true,
          defaultLoader: false,
        });
      }
    } else if (
      (apiData.data.status === 200 &&
        apiData.data.data[0]["isVerified"] === "No") ||
      apiData.data.data[0]["account_status"] !== "active"
    ) {
      auth.clientLogout();
    } else {
      console.log("Last Error");
      //this.props.history.push("/error");
    }
  };

  pageView = () => {
    const { leftClientMenuItems } = this.props;

    let urlFromParams = window.location.pathname;
    let urlSegments = urlFromParams.split("/");

    urlSegments = urlSegments.slice(1);

    if (urlSegments[0] !== "client") {
      urlSegments = urlSegments.slice(1);
    }

    const firstPart = urlSegments.slice(0, 2).join("/");
    //console.log("URL segments:", urlSegments);
    //console.log("First part of URL:", firstPart);

    const matchedMenuItem = leftClientMenuItems.find((menuItem) => {
      const menuItemLink = menuItem.link.startsWith("/")
        ? menuItem.link.slice(1)
        : menuItem.link;

      const submenuLinks = menuItem.submenu.map((submenuItem) =>
        submenuItem.link.startsWith("/")
          ? submenuItem.link.slice(1)
          : submenuItem.link
      );

      const menuItemLinkNormalized = `/${menuItemLink}`.toLowerCase();
      const firstPartNormalized = `/${firstPart}`.toLowerCase();

      if (
        menuItemLinkNormalized === firstPartNormalized ||
        submenuLinks.some(
          (submenuLink) =>
            `/${submenuLink}`.toLowerCase() === firstPartNormalized
        )
      ) {
        return true;
      }

      return false;
    });

    const shouldRenderComponent = !!matchedMenuItem;

    if (shouldRenderComponent) {
      return this.renderComponent();
    }

    const mainPages = Object.keys(pageAssociations);
    for (const mainPage of mainPages) {
      if (pageAssociations[mainPage].includes(this.state.view)) {
        const mainPageMatched = leftClientMenuItems.find((menuItem) => {
          const menuItemLink = menuItem.link.startsWith("/")
            ? menuItem.link.slice(1)
            : menuItem.link;

          const submenuLinks = menuItem.submenu.map((submenuItem) =>
            submenuItem.link.startsWith("/")
              ? submenuItem.link.slice(1)
              : submenuItem.link
          );

          const menuItemLinkNormalized = `/${menuItemLink}`.toLowerCase();
          const mainPageNormalized = `/client/${mainPage.toLowerCase()}`;

          if (
            menuItemLinkNormalized === mainPageNormalized ||
            submenuLinks.some(
              (submenuLink) =>
                `/${submenuLink}`.toLowerCase() === mainPageNormalized
            )
          ) {
            return true;
          }

          return false;
        });

        if (mainPageMatched) {
          return this.renderComponent();
        }
      }
    }

    setTimeout(() => {
      this.setState({ showAccessDenied: true });
    }, 500);

    if (this.state.showAccessDenied) {
      return <AccessDenied />;
    }
  };

  renderComponent = () => {
    let shouldRenderServices = false;
    let shouldRenderOrders = false;
    let shouldRenderRfq = false;
    switch (this.state.view) {
      case "dashboard":
        shouldRenderServices = this.props.leftClientMenuItems.some(
          (menuItem) => {
            if (menuItem.link === "/client/services") {
              return true;
            } else if (menuItem.submenu && menuItem.submenu.length > 0) {
              return menuItem.submenu.some(
                (submenuItem) => submenuItem.link === "/client/services"
              );
            }
            return false;
          }
        );

        shouldRenderOrders = this.props.leftClientMenuItems.some((menuItem) => {
          if (menuItem.link === "/client/SalesOrders") {
            return true;
          } else if (menuItem.submenu && menuItem.submenu.length > 0) {
            return menuItem.submenu.some(
              (submenuItem) => submenuItem.link === "/client/SalesOrders"
            );
          }
          return false;
        });

        shouldRenderRfq = this.props.leftClientMenuItems.some((menuItem) => {
          if (menuItem.link === "/client/Rfqs") {
            return true;
          } else if (menuItem.submenu && menuItem.submenu.length > 0) {
            return menuItem.submenu.some(
              (submenuItem) => submenuItem.link === "/client/Rfqs"
            );
          }
          return false;
        });

        return (
          <Dashboard
            props={this.props}
            shouldRenderServices={shouldRenderServices}
            shouldRenderOrders={shouldRenderOrders}
            shouldRenderRfq={shouldRenderRfq}
          />
        );
      case "services":
        return <Services props={this.props} />;
      case "Pdfdownload":
        return <Pdfdownload props={this.props} />;
      case "UnsignedAgreements":
        return <UnsignedAgreements props={this.props} />;
      case "UnsignedAgreement":
        return <UnsignedAgreement props={this.props} />;
      case "SubClients":
        return <SubClients props={this.props} />;
      case "AddSubClient":
        return <AddSubClient props={this.props} />;
      case "help":
        return <Help props={this.props} />;
      case "MetabaseReports":
        return <MetabaseReports props={this.props} />;
      case "requestReports":
        return <RequestReports props={this.props} />;
      case "editRequest":
        return <EditRequest props={this.props} />;
      case "viewRequest":
        return <ViewRequest props={this.props} />;
      case "KycForm":
        return <KycForm props={this.props} />;
      case "Rfqs":
        return <Rfqs props={this.props} />;
      case "AddRfq":
        return <AddRfq props={this.props} />;
      case "EditRfq":
        return <EditRfq props={this.props} />;
      case "Quotations":
        return <Quotations props={this.props} />;
      case "ViewQuotation":
        return <ViewQuotation props={this.props} />;
      case "SalesOrders":
        return <SalesOrders props={this.props} />;
      case "ViewSalesOrder":
        return <ViewSalesOrder props={this.props} />;
      case "EditSalesOrder":
        return <EditSalesOrder props={this.props} />;
      case "AccountActivity":
        return <AccountActivity props={this.props} />;
      case "BillingInformation":
        return <BillingInformation props={this.props} />;
      case "Invoices":
        return <Invoices props={this.props} />;
      case "PaymentHistory":
        return <PaymentHistory props={this.props} />;
      case "Pricing":
        return <Pricing props={this.props} />;
      case "Loaders":
        return <Loaders props={this.props} />;
      case "Cdr":
        return <Cdr props={this.props} />;
      case "SmsRecords":
        return <SmsRecords props={this.props} />;
      case "MouStats":
        return <MouStats props={this.props} />;
      case "BalanceUsage":
        return <BalanceUsage props={this.props} />;
      case "CreditApp":
        return <CreditApp props={this.props} />;
      case "AddCreditApp":
        return <AddCreditApp props={this.props} />;
      case "agreements":
        return <Agreements props={this.props} />;
      case "documents":
        return <ClientDocuments props={this.props} />;
      case "msa_signing":
        return <MSA />;
      case "forms":
        return <Forms props={this.props} />;
      case "client_form_submit":
        return <FormSubmit props={this.props} />;
      case "client_form_submissions":
        return <FormSubmissions props={this.props} />;
      case "client_form_submission_single":
        return <FormSubmissionSingle props={this.props} />;
      case "ApiKey":
        return <ApiKey props={this.props} />;
      default:
        return <ErrorPage />;
    }
  };

  capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  pageChange = (data) => {
    this.props.history.push("/" + data);
  };

  profileView = () => {
    this.setState({ successMessage: "", errorMessage: "" });
    window.$("#modalFormProfile").modal("show");
  };



  render() {
    return (
      <div className="nk-body bg-lighter npc-general has-sidebar ">
        <div className="nk-app-root">
          <div className="nk-main">
            {this.state.defaultLoader === true ? (
              <div>
                <div>
                  {this.state.is_msa_signed === true ? (
                    <LefeSideBar
                      mainProps={this.props}
                      menuArr={this.props.leftClientMenuItems}
                      routingUrl={this.state.routingUrl}
                      {...this.props}
                    />
                  ) : null}
                </div>
                {/*<div>
                  <DashboardLoader />
            </div>*/}
              </div>
            ) : (
              <div>
                {this.state.is_msa_signed === true ? (
                  <LefeSideBar
                    mainProps={this.props}
                    menuArr={this.props.leftClientMenuItems}
                    routingUrl={this.state.routingUrl}
                    {...this.props}
                  />
                ) : null}
              </div>
            )}

            <div className="nk-wrap ">
              <Header
                isNdaSigned={this.state.is_msa_signed}
                modalOpen={() => {
                  this.profileView();
                }}
                mainProps={this.props}
                modalLogin={() => {
                  this.loginDetailView();
                }}
                modalContactAgent={() => {
                  this.contactAgent();
                }}
              />

              {this.state.is_msa_signed === true ? (
                this.pageView()
              ) : (
                <Agreement
                  backgroundColor={this.state.bgColor}
                  vendor_signor_signature_file={
                    this.state.vendor_signor_signature_file
                  }
                  mainHistory={this.props}
                  agreementSigned={() => this.agreementSigned()}
                />
              )}
              {/* MODAL EDIT PROFILE START */}
              <div className="modal fade" tabIndex="-1" id="modalFormProfile">
                <div className="modal-dialog modal-xl" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Edit Profile</h5>
                      <a
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        style={{
                          cursor: "pointer",
                        }}
                      >
                        <em className="icon ni ni-cross"></em>
                      </a>
                    </div>

                    <div className="modal-body">
                      {/* Error Start */}
                      {this.state.errorMessage !== "" ? (
                        <div className="example-alert">
                          <div className="alert alert-pro alert-danger">
                            <div className="alert-text">
                              <h4>Error</h4>
                              <p
                                dangerouslySetInnerHTML={{
                                  __html: this.state.errorMessage,
                                }}
                              ></p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {this.state.successMessage !== "" ? (
                        <div className="example-alert">
                          <div className="alert alert-pro alert-success">
                            <div className="alert-text">
                              <h4>Success</h4>
                              <p>{this.state.successMessage}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      <br />

                      <div className="row g-4">
                        {this.state.filer_id && this.filer_id != "" && (
                          <div className="col-lg-4">
                            <div className="form-group">
                              <TextField
                                label="499 Filer ID"
                                error={this.state.errorCompName}
                                id="filer_id"
                                name="filer_id"
                                value={this.state.filer_id}
                                placeholder="499 Filer ID"
                                change={this.handleChange}
                                disabled={true}
                                type="text"
                              />
                            </div>
                          </div>
                        )}
                        <div className="col-lg-4">
                          <div className="form-group">
                            <TextField
                              label="Company Name"
                              error={this.state.errorCompName}
                              id="comp_name"
                              name="comp_name"
                              value={this.state.comp_name}
                              placeholder="Company Name"
                              change={this.handleChange}
                              type="text"
                            />
                            <small
                              className="form-text text-muted"
                              style={{
                                position: "absolute",
                                top: "80px",
                                color: "#555",
                                fontSize: "0.75rem",
                                fontWeight: "400",
                                fontFamily:
                                  '"Roboto", "Helvetica", "Arial", sans-serif',
                              }}
                            >
                              Allowed characters: (&nbsp; _ &nbsp; . &nbsp; -
                              &nbsp; , &nbsp; &amp; &nbsp; ( ) )
                            </small>
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="form-group">
                            <TextField
                              label="Full Name"
                              error={this.state.errorName}
                              id="name"
                              name="name"
                              value={this.state.name}
                              placeholder="Full Name"
                              change={this.handleChange}
                            />
                            <small
                              className="form-text text-muted"
                              style={{
                                position: "absolute",
                                top: "80px",
                                color: "#555",
                                fontSize: "0.75rem",
                                fontWeight: "400",
                                fontFamily:
                                  '"Roboto", "Helvetica", "Arial", sans-serif',
                              }}
                            >
                              Allowed characters: (&nbsp; ' &nbsp; - &nbsp; .
                              &nbsp; , )
                            </small>
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="form-group">
                            <TextField
                              label="Title"
                              error={this.state.errorTitle}
                              id="title"
                              name="title"
                              value={this.state.title}
                              placeholder="Title"
                              change={this.handleChange}
                            />
                            <small
                              className="form-text text-muted"
                              style={{
                                position: "absolute",
                                top: "80px",
                                color: "#555",
                                fontSize: "0.75rem",
                                fontWeight: "400",
                                fontFamily:
                                  '"Roboto", "Helvetica", "Arial", sans-serif',
                              }}
                            >
                              Allowed characters: (&nbsp; _ &nbsp; - &nbsp; .
                              &nbsp; &amp; &nbsp; , &nbsp; ( ) )
                            </small>
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="form-group">
                            <TextField
                              label="Email"
                              type="text"
                              error={this.state.errorEmail}
                              id="email"
                              name="email"
                              value={this.state.email}
                              placeholder="Enter your email address"
                              change={this.handleChange}
                              disabled={true}
                            />
                          </div>
                        </div>
                        <div className="col-lg-4">
                          {!this.state.isLoading && (
                            <PhoneInput
                              required
                              defaultCountry={"us"}
                              inputProps={{
                                name: "phone",
                                id: "phone",
                                maxLength: 20,
                              }}
                              style={{ marginTop: "30px" }}
                              value={this.state.phone}
                              onChange={(value) =>
                                this.handleChange({
                                  target: {
                                    name: "phone",
                                    value,
                                  },
                                })
                              }
                              helperText="Enter the phone number."
                              label="Client Phone Number"
                              ref={this.phoneInputRef}
                              onFocus={this.handleFocus}
                            />
                          )}
                        </div>
                        <div
                          id="profileUpdate"
                          className="form-group col-md-4"
                          style={{ marginBottom: "0px" }}
                        >
                          <div class="nk-block-between-md">
                            <div class="nk-block-head-content">
                              <label
                                htmlFor="googleLocation-autocomplete"
                                style={{
                                  color: "black",
                                  fontWeight: "500",
                                  marginBottom: "8px",
                                }}
                              >
                                Address
                              </label>
                            </div>
                            <div class="nk-block-head-content">
                              <ul class="nk-block-tools gx-3">
                                <li>
                                  <a
                                    onClick={this.handleToggle}
                                    class="text-primary fs-11"
                                    style={{
                                      cursor: "pointer",
                                      fontSize: "11px",
                                    }}
                                  >
                                    {this.state.toggleButtonText}
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                          {this.state.useGooglePlaces ? (
                            <GooglePlacesAutocomplete
                              apiKey={
                                process.env
                                  .REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY
                              }
                              selectProps={{
                                value: this.state.address
                                  ? {
                                    label: this.state.address,
                                    value: this.state.address,
                                  }
                                  : null,
                                onChange: this.handleAddressSelect,
                                placeholder: this.state.address
                                  ? null
                                  : "Enter your address..",
                                styles: {
                                  input: (provided) => ({
                                    ...provided,
                                    color: "black",
                                    height: "35px",
                                  }),
                                  option: (provided) => ({
                                    ...provided,
                                    color: "black",
                                  }),
                                  singleValue: (provided) => ({
                                    ...provided,
                                    color: "black",
                                  }),
                                  menu: (provided) => ({
                                    ...provided,
                                    zIndex: 9,
                                  }),
                                },
                              }}
                              className="googleLocation-autocomplete customCountrySelect.css-b62m3t-container"
                            />
                          ) : (
                            <input
                              type="text"
                              className="form-control"
                              id="address"
                              name="address"
                              value={this.state.address}
                              placeholder="Enter Po Box address"
                              onChange={this.handleChange}
                              style={{
                                borderColor: this.state.errorAddress
                                  ? "red"
                                  : "initial",
                                height: "45px",
                                border: "1px solid #dbdfea",
                                fontSize: "0.9375rem",
                              }}
                            />
                          )}
                        </div>
                        <div className="col-lg-4">
                          <div className="form-group">
                            <TextField
                              label="Apartment, Suite, Etc."
                              type="text"
                              error={this.state.errorAddress2}
                              id="address2"
                              name="address2"
                              value={this.state.address2}
                              placeholder="Apartment, Suite, Etc."
                              change={this.handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="form-group">
                            <TextField
                              label="City"
                              type="text"
                              error={this.state.errorCity}
                              id="city"
                              name="city"
                              value={this.state.city}
                              placeholder="Enter your city"
                              change={this.handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="form-group">
                            <TextField
                              label="State"
                              type="text"
                              error={this.state.errorState}
                              id="states"
                              name="states"
                              value={this.state.states}
                              placeholder="Enter your state"
                              change={this.handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="form-group">
                            <TextField
                              label="Zip Code"
                              type="text"
                              error={this.state.errorZip}
                              id="zip"
                              name="zip"
                              value={this.state.zip}
                              placeholder="Enter your zip code"
                              change={this.handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="form-group">
                            <p
                              className="MuiFormHelperText-root MuiFormHelperText-contained Mui-required"
                              style={{
                                fontSize: "0.875rem",
                                fontWeight: 500,
                                color: "#344357",
                                marginBottom: ".5rem",
                              }}
                            >
                              Select country
                            </p>
                            <Select
                              className="customStyle-country"
                              options={this.countryOptions}
                              value={{
                                label: this.state.country,
                                value: this.state.country,
                              }}
                              onChange={this.handleChangeCountry}
                              placeholder="Select a country"
                              styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  minHeight: "45px",
                                }),
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div
                            className="form-group"
                            style={{ position: "relative" }}
                          >
                            <TextField
                              label={
                                <Tooltip
                                  title="Password must be at least 8 characters, with uppercase, lowercase, number & special character."
                                  placement="top"
                                >
                                  <span>
                                    <span>
                                      <em
                                        className="icon ni ni-info"
                                        style={{ marginRight: 5 }}
                                      ></em>
                                    </span>
                                    Password
                                  </span>
                                </Tooltip>
                              }
                              type={
                                this.state.passwordShown ? "text" : "password"
                              }
                              error={this.state.errorPass}
                              id="password"
                              name="password"
                              value={this.state.password}
                              placeholder="Enter your password"
                              change={this.handleChange}
                            />
                            <a
                              style={{
                                left: "auto",
                                right: "2px",
                                top: "53px",
                                position: "absolute",
                                cursor: "pointer",
                              }}
                              tabIndex="-1"
                              onClick={() => {
                                this.togglePassword();
                              }}
                              className="form-icon form-icon-right passcode-switch"
                              data-target="password"
                            >
                              {this.state.passwordShown ? (
                                <em className="icon ni ni-eye-off"></em>
                              ) : (
                                <em className="icon ni ni-eye"></em>
                              )}
                            </a>
                            <PasswordStrengthBar
                              password={this.state.password}
                            />
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div
                            className="form-group"
                            style={{ position: "relative" }}
                          >
                            <TextField
                              label={
                                <Tooltip
                                  title="Confirm Password must be at least 8 characters, with uppercase, lowercase, number & special character. Confirm Password must match the Password."
                                  placement="top"
                                >
                                  <span>
                                    <span>
                                      <em
                                        className="icon ni ni-info"
                                        style={{ marginRight: 5 }}
                                      ></em>
                                    </span>
                                    Confirm Password
                                  </span>
                                </Tooltip>
                              }
                              type={
                                this.state.confirmPasswordShown
                                  ? "text"
                                  : "password"
                              }
                              error={this.state.errorPass}
                              id="confirm_password"
                              name="confirm_password"
                              value={this.state.confirm_password}
                              placeholder="Enter confirm password"
                              change={this.handleChange}
                            />
                            <a
                              style={{
                                left: "auto",
                                right: "2px",
                                top: "53px",
                                position: "absolute",
                                cursor: "pointer",
                              }}
                              tabIndex="-1"
                              onClick={() => {
                                this.toggleConfirmPassword();
                              }}
                              className="form-icon form-icon-right passcode-switch"
                              data-target="comfirm-password"
                            >
                              {this.state.confirmPasswordShown ? (
                                <em className="icon ni ni-eye-off"></em>
                              ) : (
                                <em className="icon ni ni-eye"></em>
                              )}
                            </a>
                          </div>
                        </div>
                        <div className="col-lg-4">&nbsp;</div>
                        <div style={{ clear: "both" }}></div>
                        {/* <div className="form-group">
                        <label className="form-label" htmlFor="password">
                          Password
                        </label>
                        <div className="form-control-wrap">
                          <a
                            tabIndex="-1"
                            href="#"
                            className="form-icon form-icon-right passcode-switch"
                            data-target="password"
                          >
                            <em className="passcode-icon icon-show icon ni ni-eye"></em>
                            <em className="passcode-icon icon-hide icon ni ni-eye-off"></em>
                          </a>
                          <input
                            type="password"
                            className={
                              "form-control form-control-lg " +
                              this.state.errorPass
                            }
                            id="password"
                            name="password"
                            value={this.state.password}
                            onChange={this.handleChange}
                            placeholder="Enter your password"
                          />
                        </div>
                      </div> */}
                        <div className="col-lg-12 text-right">
                          <button
                            type="button"
                            className="btn btn-lg"
                            onClick={() => {
                              this.formUpdate();
                            }}
                            style={{
                              backgroundColor: THEME_COLOR,
                              color: THEME_TEXT_COLOR,
                              float: "right",
                            }}
                            disabled={this.state.disabled}
                          >
                            Update Profile
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* END MODAL EDIT PROFILE */}
              {/* Alert Permission */}
              <div class="modal fade" tabindex="-1" id="modalAlertPermission">
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-body modal-body-lg text-center">
                      <div className="nk-modal">
                        <em
                          class="icon ni ni-alert-circle"
                          style={{ fontSize: "3rem" }}
                        ></em>

                        <h4 className="nk-modal-title">No Permission</h4>
                        <div className="nk-modal-text">
                          <div className="caption-text">
                            You do not have permission to access the VoiceAlerts
                            dashboard. Please contact the administrator for
                            access.
                          </div>
                        </div>
                        <div className="nk-modal-action">
                          <a
                            style={{ cursor: "pointer", color: "#fff" }}
                            className="btn btn-lg btn-mw btn-secondary"
                            onClick={() => {
                              this.modalHideRemoveAlert("modalAlertPermission");
                            }}
                            disabled={this.state.disabled}
                          >
                            CLOSE
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Alert Permission */}
              {/* { MODAL LOGIN DETAILS } */}
              <div
                className="modal fade"
                id="modalLoginDetail"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="modalLoginDetailLabel"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-xl modal-dialog-top"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="modalLoginDetailLabel">
                        Login Details
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        style={{
                          outline: "none",
                          boxShadow: "none",
                          border: "none",
                          backgroundColor: "transparent",
                        }}
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      {/* Table to Display Login Details */}
                      <div className="table-responsive">
                        <table className="table table-bordered">
                          <thead className="thead-light">
                            <tr>
                              <th>IP Address</th>
                              <th>Country</th>
                              <th>State</th>
                              <th>City</th>
                              <th>Timezone</th>
                              <th>Login Time</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.loginDetails &&
                              this.state.loginDetails.length > 0 ? (
                              this.state.loginDetails.map((detail, index) => (
                                <tr key={index}>
                                  <td>{detail.ip_address}</td>
                                  <td>{detail.country}</td>
                                  <td>{detail.state}</td>
                                  <td>{detail.city}</td>
                                  <td>{detail.time_zone}</td>
                                  <td>
                                    {new Date(detail.login_time)
                                      .toLocaleDateString("en-US", {
                                        month: "long",
                                        day: "numeric",
                                        year: "numeric",
                                      })
                                      .replace(/(\d+)(?=,)/, "$1th")}
                                    ,{" "}
                                    {new Date(
                                      detail.login_time
                                    ).toLocaleTimeString("en-US")}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="6" className="text-center">
                                  No login details found.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* { MODAL LOGIN DETAILS } */}
              {/***  CONTACT AGENT  ***/}
              <div class="modal fade" tabindex="-1" id="modalContactAgent">
                <div
                  className="modal-dialog modal-dialog-top modal-xl"
                  role="document"
                >
                  <div className="modal-content">
                    <a
                      href="#"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                    <div className="modal-header">
                      <h5 className="modal-title">
                        <em class="icon ni ni-emails"></em> Contact Agent
                      </h5>
                    </div>
                    <div className="modal-body">
                      <h6>Agent Details</h6>
                      <div
                        className="card card-bordered"
                        id="creditApplicationTables"
                      >
                        <table className="table table-striped table-bordered">
                          <thead></thead>
                          <tbody>
                            <tr>
                              <td style={{ fontWeight: "bold" }}>Name</td>
                              <td>Sajid Riaz</td>
                            </tr>
                            <tr>
                              <td style={{ fontWeight: "bold" }}>Email</td>
                              <td></td>
                            </tr>
                            <tr>
                              <td style={{ fontWeight: "bold" }}>Phone</td>
                              <td></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <h6 className="pt-4 pb-4">Send Email</h6>
                      <div className="row g-4">

                        {this.state.errorMessageContactAgent !== "" ? (
                          <div className="col-md-12 mb-3">
                            <div
                              className="example-alert example-alert-revoke"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-danger">
                                <div className="alert-text">
                                  <h4>Error</h4>
                                  <p>{this.state.errorMessageContactAgent}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : null}
                        {this.state.successMessageContactAgent !== "" ? (
                          <div className="col-md-12 mb-3">
                            <div
                              className="example-alert example-alert-revoke"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-success">
                                <div className="alert-text">
                                  <h4>Success</h4>
                                  <p>{this.state.successMessageContactAgent}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : null}

                        <div className="col-md-12">
                          <div className="form-group">
                            <div className="form-control-group">
                              <MutextField
                                required
                                id="contact_subject"
                                name="contact_subject"
                                type="text"
                                label="Subject"
                                defaultValue={this.state.contact_subject}
                                inputProps={{ maxLength: 64 }}
                                onInput={(e) => {
                                  e.target.value = e.target.value.replace(
                                    /[^a-zA-Z0-9 ]/gi,
                                    ""
                                  );
                                }}
                                helperText="Enter the subject here."
                                onChange={this.handleChange}
                                variant="outlined"
                                fullWidth
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-12">
                          <div className="form-group">
                            <div className="form-control-group">
                              <TextareaAutosize
                                maxrows={4}
                                name="contact_comment"
                                id="contact_comment"
                                aria-label=""
                                placeholder="Add Comment *"
                                inputProps={{ maxLength: 500 }}
                                //maxLength={500}
                                value={this.state.contact_comment}
                                helperText="Maximum 500 characters"
                                onChange={this.handleChange}
                                style={{
                                  width: "100%",
                                  height: "100px",
                                  borderColor: "rgba(0, 0, 0, 0.125)",
                                  borderRadius: "4px",
                                  padding: "5px",
                                }}
                                variant="outlined"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-12">
                          <div className="example-alert">
                            <div className="alert alert-light">
                              <ul className="list">
                                <li>
                                  An email will be sent to your assigned agent's email address, including the subject and comment.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer text-right d-flex justify-content-end">
                      <a
                        href="#"
                        className="btn btn-mw btn-light"
                        data-dismiss="modal"
                      >
                        Close
                      </a>
                      <button
                        type="button"
                        onClick={() => this.contactAgentSubmit()}
                        className="btn btn-primary"
                        disabled={this.state.disabled}
                      >
                        <span>Send Email</span>{" "}
                        <em className="icon ni ni-emails"></em>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {/***  CONTACT AGENT  ***/}
              <Footer />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    state,
    leftClientMenuItems: state.leftClientMenuItems,
    quotationSettings: state.quotationSettings,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
    addMsaInfo: (payload) => dispatch(addMsaInfo(payload)),
    setClientLeftMenu: (menuClientItems) =>
      dispatch(setClientLeftMenu(menuClientItems)),
    setQuotationSettings: (quotationsettings) =>
      dispatch(setQuotationSettings(quotationsettings)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Main);
